export default __webpack_public_path__ + "static/media/icon_laptop_mac.2bd444ed.svg";